import pwrAustraliaDefaults from '../824dc1-3/config.js';

export default {
  ...pwrAustraliaDefaults,
  includes: ['shopify-generic', '824dc1-3'],
};
